"use strict";

var Backbone = require("backbone");
var $ = require("jquery");
var _ = require("underscore");
Backbone.$ = $;

var DomUtil = require("../../common/utils/dom-util");

var debug = require("debug")("views:PageView"); //https://github.com/visionmedia/debug


/**
 * PageView: a domument page view
 * Triggers:
 * - "render"
 */
module.exports = Backbone.View.extend({

	documentModel: null, // DocumentModel
	model: null, // PageModel
	template: null, // external template for place holder
	className: "page-view",
	zoomMax: 1, // maximum zoom value : 1 = full image resolution
	page: 0,
	startFit: null, // rectangle qui doit apparaitre initialement, en coordonnées image
	isPortrait: false,
	usePDF: false,
	zoomFav: 1,
	reversed: false,
	tileHd: false, // utilise le niveau de tuile supérieur
	authorizedPage: true,
	authorizationTemplate: null,
	authorizationMessage: null,

	// private
	_x: 0, // x image position
	_y: 0, // y image position
	_zoom: -1, // current zoom
	_zoomFit: 1, // zoom value fiting entire image into viewport, computed when size change
	_animating: false, // animation in progress
	_dragEvents: null, //
	_dragStartPoint: null,
	_dragStartPagePoint: null,
	_lastTap: 0,

	events: {
		"DOMMouseScroll": "onMouseWheel",
		"mousewheel": "onMouseWheel",
		"wheel": "onMouseWheel",
		"pointerdown": "onDragStart",
		"webkitTransitionEnd": "onTransitionEnd",
		"transitionend": "onTransitionEnd"
	},

	/**
	 * @param  {Object}         options
	 * @param  {DocumentModel}  options.documentModel we use this model to gain some production properties and to get a reference to the pageModel
	 * @param  {Number}         options.page left page number
	 * @param  {String}         options.template page placeholder underscore template (optional)
	 */
	initialize: function (options) {
		var T = this;
		_.extend(T, options);

		T._dragStartPoint = {
			x: 0,
			y: 0
		};
		T._dragStartPagePoint = {
			x: 0,
			y: 0
		};
		T._dragEvents = [];
		T._pointers = {};
		T._computeCache = {}; // cache some computing values
		T._tiles = {}; // contains all tiles
		T._visible = []; // ids of visible tiles

		T._lockX = false;

		T.model = T.documentModel.getPageModel(T.page);
		if (T.documentModel.get("pdfDocument")) {
			T.usePDF = true;
		}

		T.listenTo(T.model, "sync", T.render);

		if (T.template) {
			T.template = _.template(T.template); // compile template
		}

		if (T.authorizationTemplate) {
			T.authorizationTemplate = _.template(T.authorizationTemplate); // compile template
		}

		T.transitionStyle = DomUtil.styleSupport("transition");

		// load this low res image before any tile
		if (!T.usePDF && T.authorizedPage) {
			$("<img/>").attr("src", T.model.thumbnailUrl());
		}

	},

	render: function () {
		var T = this,
			context = T.model.toJSON();

		debug("render " + T.model.get("id") + ", fetched: " + T.model.fetched);

		if (T.template) {
			if (T.documentModel.get("reversed")) {
				context.id = T.documentModel.get("nbPages") - parseInt(context.id) + 1;
			}
			T.$el.html(T.template(context));
		}

		if (T.model.fetched) {
			T.$tileContainer = $("<div/>", {
				class: "tile-container",
			}).appendTo(T.el);

			if (!T.usePDF && T.authorizedPage) {
				T.$tileContainer.css({
					backgroundImage: "url(" + T.model.thumbnailUrl() + ")"
				});
			}

			if (!T.authorizedPage) {
				T.renderPageAuthorization();
			}

			var fit_values = T._computeFit();
			T._zoomFit = fit_values.z;

			if (T.startFit) {
				T.fitRectangle(T.startFit);
			} else {
				T.fit(false);
			}

		}

		T.trigger("render", T);
	},

	/**
	 * fit tileContainer into main element
	 * @param  {Bool} animated
	 */
	fit: function (animated) {
		var T = this,
			fit_values = T._computeFit();

		if (!fit_values) return;

		T.setPosition(fit_values.x, fit_values.y, fit_values.z, true, animated);
	},

	_computeFit: function () {
		var T = this;
		if (!T.model.fetched) return;
		var x = 0,
			y = 0,
			z = 1,
			elW = T.$el.width(),
			elH = T.$el.height(),
			imW = T.model.get("width"),
			imH = T.model.get("height");

		if (T.isPortrait && T.model.get("isDouble")) {
			imW /= 2;
		}

		z = elW / imW;
		if (z * imH > elH) {
			z = elH / imH;
			x = ((elW / z) - imW) / 2;
		} else {
			y = ((elH / z) - imH) / 2;
		}
		return {
			x: x,
			y: y,
			z: z
		};
	},

	/**
	 * zoome la page pour que la view affiche le rectangle passé en paramètre
	 * @param  {Object} rect rectangle en coordonnées image {"x":"200","y":"200","width":"300","height":"400"}
	 * @param  {Bool} animated
	 */
	fitRectangle: function (rect, animated) {
		var T = this;
		if (!T.model.fetched) return;
		var x = 0,
			y = 0,
			z = 1,
			elW = T.$el.width(),
			elH = T.$el.height();

		z = elW / rect.width;
		if (z * rect.height > elH) {
			z = elH / rect.height;
			x = -(rect.x + (rect.width / 2) - ((elW / z) / 2));
			y = -rect.y;
		} else {
			x = -rect.x;
			y = -(rect.y + (rect.height / 2) - ((elH / z) / 2)); //((elH / z) - imH) / 2;
		}

		T.setPosition(x, y, z, true, animated);
	},

	/**
	 * set tileContainer position
	 * @param {Int} x        x position in image coordinates
	 * @param {Int} y        y position in image coordinates
	 * @param {Float} zoom
	 * @param {Bool} animated
	 */
	setPosition: function (x, y, zoom, clamp, animated) { // jshint ignore:line
		var T = this;
		if (!T.model.fetched) return;
		if (!T.$tileContainer) return;

		if (clamp) {
			var pt = T._clampPosition(x, y, zoom);
			x = pt.x;
			y = pt.y;
		}

		if (T._x == x && T._y == y && T._zoom == zoom) {
			return;
		}

		// on arrondit à l'entier car le css des browsers fonctionnent en entier
		// donc si il y a juste une variation de la partie après la virgule, ça ne déclenchera pas d'animation
		var new_vpx = Math.round(x * zoom),
			new_vpy = Math.round(y * zoom),
			old_vpx = Math.round(T.$tileContainer[0].offsetLeft),
			old_vpy = Math.round(T.$tileContainer[0].offsetTop);

		if (new_vpx == old_vpx && new_vpy == old_vpy) {
			animated = false;
		}

		T._x = x;
		T._y = y;
		T._zoom = zoom;

		T.trigger("change:position", T);

		var style = {};

		style[T.transitionStyle] = animated ? "left 0.5s, width 0.5s, height 0.5s, top 0.5s" : "none";

		T.$tileContainer.css(style);

		style = {
			width: T.model.get("width") * zoom,
			height: T.model.get("height") * zoom,
			left: new_vpx,
			top: new_vpy
		};
		T.$tileContainer.css(style);

		if (animated) {
			//debug("animating true");
			T._animating = true;
			T.hideTiles();
		} else {
			if (T._animating) {
				T.onAnimationEnd();
			}
			else {
				T.refresh();
			}
		}
	},

	resize: function () {
		var T = this,
			fit_values,
			was_zoomed = T.isZoomed();

		fit_values = T._computeFit();
		if (!fit_values) return;

		T._zoomFit = fit_values.z;

		if (was_zoomed) {
			// on était zoomé dans le doc, on se repositionne vers les mêmes positions
			var z = T._clampZoom(T._zoom);
			T.setPosition(T._x, T._y, z, true, false);
			T.refresh(); // force refresh
		} else {
			// on était en mode fit
			T.fit(false);
		}
	},

	getPosition: function () {
		var T = this;
		return {
			x: T._x,
			y: T._y,
			zoom: T._zoom
		};
	},

	refreshPDF: function () {
		// version qui calcule un canvas à chaque zoom
		var T = this;

		if (T._animating) {
			//debug("refresh PDF " + T.page + " aborted due to animation");
			return;
		}

		// on ne rien faire si le zoom n'a pas changé depuis le dernier refresh
		if (T._zoom == T._lastZoom) {
			//debug("refresh PDF " + T.page + " aborted due to zoom not changed since last time");
			return;
		}

		T._lastZoom = T._zoom;

		var nb_pages;
		if (T.isPortrait) {
			nb_pages = 1;
		}
		else {
			nb_pages = T.model.get("isDouble") ? 2 : 1;
		}

		for (var i = 0; i < nb_pages; i++) {
			T.renderPDFPage(i);
		}
	},

	renderPDFPage: function (i) {
		var T = this, nb_pages, canvas_width, canvas_height, canvas_width_percent;
		var resolution = T._zoom;

		debug("render page " + (T.page + i) + " " + resolution);

		T.documentModel.get("pdfDocument").getPage(T.page + i).then(function (page) {

			var tile_id = "T-PDF-" + (T.page + i) + "-" + String(resolution);
			var left;

			if (T.isPortrait) {
				nb_pages = 1;
				if (T.model.get("isDouble")) {
					canvas_width = Math.ceil(T.$tileContainer.width() / 2);
					if (T.isLeftPage()) {
						left = 0;
					}
					else {
						left = "50%";
					}
					canvas_width_percent = 50;
				}
				else {
					left = 0;
					canvas_width = Math.ceil(T.$tileContainer.width() / nb_pages);
					canvas_width_percent = 100;
				}
			}
			else {
				nb_pages = T.model.get("isDouble") ? 2 : 1;
				left = (100 / nb_pages) * i + "%";
				canvas_width = Math.ceil(T.$tileContainer.width() / nb_pages);
				canvas_width_percent = 100 / nb_pages;
			}

			canvas_height = Math.ceil(T.$tileContainer.height());



			//debug("create canvas");
			var $tile = $('<canvas/>', {
				class: "tile-pdf-" + i,
				id: tile_id,
				css: {
					position: "absolute",
					top: 0,
					left: left,
					backgroundColor: "transparent",
				}
			});

			if (window.devicePixelRatio > 1) {
				// on met plus de pixels pour les écrans type retina
				canvas_width *= 1.4;
				canvas_height *= 1.4;
				$tile.css({
					width: canvas_width_percent + "%",
					height: "100%"
				});
			}
			else {
				$tile.css({
					width: canvas_width,
					height: canvas_height
				});
			}

			var canvas = $tile[0];

			var viewport_original = page.getViewport({ scale: 1 });

			var scale = canvas_width / viewport_original.width;
			var viewport = page.getViewport({ scale: scale });

			var context = canvas.getContext('2d');
			canvas.height = canvas_height;
			canvas.width = canvas_width;

			var renderContext = {
				canvasContext: context,
				viewport: viewport,
				enableWebGL: true
			};

			page.render(renderContext).promise.then(function () {

				if (T._animating) {
					// le rendu se finit pendant qu'une animation est en cours, on ne fait rien avec la tuile, un refresh sera appelé à la fin de l'animation
					//debug("animation in progress");
					T._lastZoom = 0;
				}
				else {
					if (!T.$tileContainer) return; // l'objet page a été supprimé lors d'un redimensionnement par exemple
					T.$('.tile-pdf-' + i).remove();

					if (window.devicePixelRatio == 1) {
						// plus d'animation en cours, on met une taille en pixel pour que le texte soit bien net, pour ne pas avoir des dixièmes de pixels
						$tile.css({
							width: canvas_width,
							height: canvas_height,
						});
					}
					T.$tileContainer.append($tile);
				}

			});
		});
	},

	renderPageAuthorization: function () {
		var T = this;
		if (!T.authorizationTemplate) return;
		if (!T.$tileContainer) return; // l'objet page a été supprimé lors d'un redimensionnement par exemple

		var context = T.model.toJSON();

		if (T.documentModel.get("reversed")) {
			context.id = T.documentModel.get("nbPages") - parseInt(context.id) + 1;
		}

		context.thumbnailUrl = T.model.thumbnailUrl();

		var message;
		
		if (_.isFunction(T.authorizationMessage)) {
			var content_model = T.documentModel.toJSON();
			content_model.documentId=content_model.id;
			content_model.documentTitle=content_model.title;
			delete(content_model.id);
			delete(content_model.title);
			content_model.contentType = "page";
			content_model.pages = T.model.get("number");
			message = T.authorizationMessage(content_model);
		}
		else {
			message = T.authorizationMessage;
		}

		context.authorizationMessage = message;
		

		T.$tileContainer.empty();
		T.$tileContainer.addClass("page-auth-container");

		var html_code = T.authorizationTemplate(context);
		if (T.isPortrait && T.model.get("isDouble")) {
			T.$tileContainer.append($(html_code).addClass("mid"));
			T.$tileContainer.append($(html_code).addClass("mid"));
		}
		else {
			T.$tileContainer.append(html_code);
		}
	},

	/**
	 * tiles management (create/remove/position) depending of zoom and position into viewport
	 */
	refresh: function () {
		var T = this;

		if (T._pinching) return;

		if (!T.authorizedPage) {
			return;
		}

		if (T.usePDF) {
			T.refreshPDF();
			return;
		}

		var imTileSize = T.model.get("tileSize");

		// recherche du niveau de tuiles à charger en fonction du zoom
		// on cache les dernières valeurs obtenue si le zoom ne change pas pour éviter des calculs
		var ll, zdiv, its, t1, t2, nbtht, nbtvt;
		if (T._computeCache.zoom == T._zoom) {
			ll = T._computeCache.ll;
			zdiv = T._computeCache.zdiv;
			its = T._computeCache.its;
			t1 = T._computeCache.t1;
			t2 = T._computeCache.t2;
			nbtht = T._computeCache.nbtht;
			nbtvt = T._computeCache.nbtvt;
		} else {
			ll = T._determineLevel(T._zoom);
			zdiv = T._zoom / ll.z;
			its = imTileSize / ll.z; //taille d une tuile de ce level dans le repère de l image
			t1 = T.model.get("width") * ll.z; //largeur de l'image de ce level
			t2 = T.model.get("height") * ll.z; //hauteur de l'image de ce level
			nbtht = Math.ceil(t1 / imTileSize); // nombre total de tuiles horizontales
			nbtvt = Math.ceil(t2 / imTileSize); // nombre total de tuiles verticales

			T._computeCache = {
				ll: ll,
				zdiv: zdiv,
				its: its,
				t1: t1,
				t2: t2,
				nbtht: nbtht,
				nbtvt: nbtvt,
				zoom: T._zoom
			};
		}

		//viewport dans le repère de l image
		var ivpw = T.$el.width() / T._zoom;
		var ivph = T.$el.height() / T._zoom;

		var firstTileH = Math.floor(-T._x / its); // first tile
		var firstTileV = Math.floor(-T._y / its);
		if (firstTileH < 0) firstTileH = 0;
		if (firstTileV < 0) firstTileV = 0;

		var lastTileH = Math.floor((-T._x + ivpw) / its); // last tile
		var lastTileV = Math.floor((-T._y + ivph) / its);
		if (lastTileH > nbtht - 1) lastTileH = nbtht - 1;
		if (lastTileV > nbtvt - 1) lastTileV = nbtvt - 1;

		//IM.log("Page:"+T.numbering+" firstTileH:"+firstTileH+" firstTileV:"+firstTileV+" X:"+T._iX+" lastTileH:"+lastTileH+" lastTileV:"+lastTileV);

		// we hide all the tiles that are no longer useful
		for (var k = 0; k < T._visible.length; k++) {
			var $tile_visible = T._tiles[T._visible[k]],
				data = $tile_visible.pv5data;
			if (data.level == ll.l) {
				if (!(data.h >= firstTileH && data.h <= lastTileH && data.v >= firstTileV && data.v <= lastTileV)) {
					$tile_visible.hide();
				}
			} else {
				$tile_visible.hide();
			}
		}

		T._visible = [];

		// positionnement/chargement tuiles si nécéssaire
		var hDst, wDst, yDst, xDst;
		xDst = yDst = wDst = hDst = 0;
		yDst = Math.round(((firstTileV * its)) * T._zoom);

		for (var j = firstTileV; j <= lastTileV; j++) {
			xDst = Math.round(((firstTileH * its)) * T._zoom);
			if (j == nbtvt - 1)
				hDst = Math.round((t2 - (imTileSize * (nbtvt - 1))) * zdiv);
			else
				hDst = Math.round(imTileSize * zdiv);

			for (var i = firstTileH; i <= lastTileH; i++) {
				if (i == nbtht - 1)
					wDst = Math.round((t1 - (imTileSize * (nbtht - 1))) * zdiv); //dernière tuile horizontale
				else
					wDst = Math.round(imTileSize * zdiv);

				//console.log("Page:"+T.page+" Level:"+ll.l+" line:"+j+" col:"+i);
				var tile_id = "T-" + ll.l + "-" + i + "-" + j;
				var $tile = T._tiles[tile_id];

				if (!$tile) {
					// not found, create a new tile
					$tile = $("<img/>", {
						class: "tile",
						id: tile_id,
						src: T.model.tileUrl(i, j, ll.l),
						draggable: false
					});
					$tile.pv5data = {
						level: ll.l,
						h: i,
						v: j
					};
					T._tiles[tile_id] = $tile;
					T.$tileContainer.append($tile);
					//console.log("new tile "+i+" "+j+" "+ll.l);
				}

				if ($tile) {
					T._visible.push(tile_id);
					$tile.css({
						width: wDst,
						height: hDst,
						top: yDst,
						left: xDst,
						display: ""
					});
				}

				xDst += wDst;
			}
			yDst += hDst;
		}

	},

	/**
	 * zoom current page
	 * @param  {String|float} zoom  command ("in"|"out") or value (0->1)
	 * @param  {Bool} animated
	 */
	zoom: function (zoom, animated) {
		var T = this,
			z = 1,
			pt = {
				x: T.$el.width() / 2,
				y: T.$el.height() / 2
			};

		T._vpToImage(pt);

		if (_.isString(zoom)) {
			if (zoom == "in") {
				z = T._zoom * 2;
			} else if (zoom == "out") {
				z = T._zoom / 2;
			} else if (zoom == "fit") {
				T.fit(animated);
				return;
			} else {
				// unsupported command
				return;
			}
		} else {
			z = zoom;
		}

		z = T._clampZoom(z);

		T.zoomCentered(pt.x, pt.y, z, T.$el.width() / 2, T.$el.height() / 2, true, animated);

	},

	/**
	 * zoome la page, centré sur le le point passé
	 * @param {int} x position x dans le repère de l'image
	 * @param {int} y position y dans le repère de l'image
	 * @param {float} s nouveau facteur de zoom
	 * @param {int} vpx position x dans le repère du viewport
	 * @param {int} vpy position y dans le repère du viewport
	 * @param {bool} clamp autorise ou non à dépasser les limite du viewport
	 * @param {bool} animated zoome animé ou zoom direct
	 */
	zoomCentered: function (x, y, s, vpx, vpy, clamp, animated) { // jshint ignore:line
		var T = this,
			newX = 0,
			newY = -y + (vpy / s);

		if (!T.authorizedPage) return;

		//console.log("old: "+T._zoom+" new: "+s);
		if (T.isPortrait) {
			if (T.model.get("isDouble")) {
				if (T.isLeftPage()) {
					newX = -x + (vpx / s);
				} else {
					newX = -x + (vpx / s) - T.model.get("width") / 2;
				}
			} else {
				newX = -x + (vpx / s);
			}
		} else {
			newX = -x + (vpx / s);
		}
		//IM.log("X:"+x+" Y:"+y+" S:"+s);
		T.setPosition(newX, newY, s, clamp, animated);
	},

	/**
	 * donne la correspondance entre un point dans le viewport et un point dans l'image originale
	 * @param {Object} pt {x:0,y:0} point demandé, le résultat sera retourné dans cet objet directement
	 * @ignore
	 */
	_vpToImage: function (pt) {
		var T = this,
			x,
			y;

		if (T.model.get("isDouble")) {
			if (T.isPortrait) {
				if (T.isLeftPage()) {
					x = (pt.x / T._zoom) - T._x;
					y = (pt.y / T._zoom) - T._y;
				} else {
					x = (pt.x / T._zoom) - T._x - T.model.get("width") / 2; // todo, à vérifier
					y = (pt.y / T._zoom) - T._y;
				}
			} else {
				x = (pt.x / T._zoom) - T._x;
				y = (pt.y / T._zoom) - T._y;
			}
		} else {
			x = (pt.x / T._zoom) - T._x;
			y = (pt.y / T._zoom) - T._y;
		}

		pt.x = x;
		pt.y = y;
	},

	/**
	 * limite une position x,y en fonction d'un facteur de zoom
	 * @param {Object} pt {x:0,y:0} point demandé, le résultat sera retourné dans cet objet directement
	 * @param {float} z zoom demandé
	 * @ignore
	 */
	_clampPosition: function (x, y, z) { // jshint ignore:line

		var T = this,
			newX = x,
			newY = y,
			elW = T.$el.width(),
			elH = T.$el.height(),
			maxX = 0,
			minX = 0,
			imWidth = T.model.get("width"),
			imHeight = T.model.get("height");

		//todo : mettre le calcule de min et max une seule fois sur resize
		// clamp X
		if (T.isPortrait) {
			if (T.model.get("isDouble")) {
				if (T.isLeftPage()) {
					maxX -= ((imWidth / 2) - (elW / z)); // ok
					if (newX > minX) newX = minX;
					if (newX < maxX) newX = maxX;
				} else {
					minX = -(imWidth / 2); //ok
					maxX = -imWidth + (elW / z);
					if (newX < maxX) newX = maxX;
					if (newX > minX) newX = minX;
				}
			} else {
				maxX -= (imWidth - (elW / z)); // page simple centrée; ok
				if (maxX > 0) maxX /= 2; // cas où on a dézoomé assez et donc on centre horizontalement
				if (newX > minX) newX = minX;
				if (newX < maxX) newX = maxX;
			}
		} else {
			maxX -= (imWidth - (elW / z));
			if (maxX > 0) maxX /= 2; // cas où on a dézoomé assez et donc on centre horizontalement
			if (newX > minX) newX = minX;
			if (newX < maxX) newX = maxX;
		}

		//console.log("x: "+x+" MIN X:"+minX+" MAX X:"+maxX+" vp W :"+elW);

		// clamp Y
		var maxY = -(imHeight - (elH / z));
		if (maxY > 0) maxY /= 2; // cas où on a dézoomé assez et donc on centre verticalement
		if (newY > 0) newY = 0;
		if (newY < maxY) newY = maxY;

		//IM.log("MAX Y:"+maxY);
		return ({
			x: newX,
			y: newY
		});
	},

	_clampZoom: function (z) {
		var T = this;
		if (z > T.zoomMax) {
			z = T.zoomMax;
		} else if (z < T._zoomFit) {
			z = T._zoomFit;
		}
		return z;
	},

	/**
	 * determine image level needed for this image zoom value
	 * @param  {float} zoom
	 * @return {int}   image level
	 */
	_determineLevel: function (zoom) {
		var T = this,
			v = 1,
			l = 0,
			imLevels = T.model.get("nbLevels"),
			imDivider = T.model.get("divider");

		if (zoom > 0 && zoom < 1) {
			for (var k = 0; k < imLevels; k++) {
				v /= imDivider;
				if (v < zoom) {
					v *= imDivider;
					break;
				}
				l++;
			}
		}

		// en 2019 : force le niveau supérieur
		if (T.tileHd) {
			l--; v *= imDivider;
		}

		if (l >= imLevels) {
			l = imLevels - 1;
		} else if (l < 0) {
			l = 0;
			v = 1;
		}
		//debug("levels",l,v);
		return {
			l: l,
			z: v
		};
	},

	isZoomed: function () {
		var T = this;
		return (T._zoom >= T._zoomFit * 1.1) ? true : false;
	},

	onMouseWheel: function (ev) {
		var T = this,
			wheelDeltaY,
			new_zoom,
			e = ev.originalEvent;

		if (e.wheelDeltaX) {
			wheelDeltaY = e.wheelDeltaY / 12;
		} else if (e.wheelDelta) {
			wheelDeltaY = e.wheelDelta / 12;
		} else if (e.detail) {
			wheelDeltaY = -e.detail * 3;
		} else {
			return; //unknown case
		}

		new_zoom = T._zoom * Math.pow(2, 1 / 3 * (wheelDeltaY ? wheelDeltaY / Math.abs(wheelDeltaY) : 0));
		new_zoom = T._clampZoom(new_zoom);

		if (new_zoom != T._zoom) {
			var offset = T.$el.offset(),
				mouseX = e.pageX - offset.left,
				mouseY = e.pageY - offset.top,
				pt = {
					x: mouseX,
					y: mouseY
				};

			T._vpToImage(pt);
			//console.log(pt.x+" "+pt.y);
			T.zoomCentered(pt.x, pt.y, new_zoom, mouseX, mouseY, true, true);
			T.saveZoomFav(T._zoom);
		}

		// lignes ci-dessous necessaires pour le fonctionnement en iframe pour que l'action de zoom par scroll ne se transforme pas en scroll de la page web qui contient l'iframe
		e.stopPropagation();
		e.preventDefault();
	},

	onTransitionEnd: function (e) {
		var T = this;
		//debug("transition end",e.originalEvent.propertyName);
		if (e.target == T.$tileContainer[0] && e.originalEvent.propertyName == "width") {
			T.onAnimationEnd();
			e.stopPropagation();
		}
	},

	onAnimationEnd: function () {
		var T = this;
		T._animating = false;
		//debug("animating false"); 
		T.refresh();
	},

	onDragStart: function (e) {
		var T = this,
			offset,
			pt;

		if (!T.$tileContainer) return;

		T._pointers[e.originalEvent.pointerId] = {
			pageX: e.pageX,
			pageY: e.pageY
		};

		var keys = _.keys(T._pointers);

		if (keys.length == 1) {
			var now = Date.now(),
				isTapTap = false;

			if (now - T._lastTap < 400) {
				// double tap
				isTapTap = true;
			}

			if (isTapTap) {
				if (T.isZoomed()) {
					T.fit(true);
				} else {
					offset = T.$el.offset();
					pt = {
						x: e.pageX - offset.left,
						y: e.pageY - offset.top
					};
					T._vpToImage(pt);
					T.zoomCentered(pt.x, pt.y, T.zoomFav, T.$el.width() / 2, T.$el.height() / 2, true, true);
				}
				e.preventDefault();
			}

			T._lockTested = false;
			T._dragStartPagePoint.x = T._x;
			T._dragStartPagePoint.y = T._y;
			// en 2015 firefox donne le timlestamp en micro secondes au lieu de millisecondes ... bug ?
			// du coup on ne peut pas utiliser le timeStamp, on stocke la date
			e.pv5TimeStamp = now;
			T._dragEvents = [e]; // inertia management
			T._dragStartPoint.x = e.pageX;
			T._dragStartPoint.y = e.pageY;

			$(window).on("pointermove.pv5-page", function (e) {
				T.onDragMove(e);
			});
			$(window).on("pointerup.pv5-page", function (e) {
				T.onDragEnd(e);
			});
			$(window).on("pointercancel.pv5-page", function (e) {
				T.onDragEnd(e);
			});

			T._lastTap = now;
		} else if (keys.length == 2) {
			var t1 = T._pointers[keys[0]];
			var t2 = T._pointers[keys[1]];

			var midX = (Math.abs(((t2.pageX - t1.pageX) / 2)) + t1.pageX);
			var midY = (Math.abs(((t2.pageY - t1.pageY) / 2)) + t1.pageY);
			offset = T.$el.offset();
			pt = {
				x: midX - offset.left,
				y: midY - offset.top
			};
			T._vpToImage(pt);
			T._touchStartMidPt = pt;
			T._touchStartDist = Math.sqrt(Math.pow((t1.pageX - t2.pageX), 2) + Math.pow((t1.pageY - t2.pageY), 2));
			T._touchStartScale = T._zoom;
		}
	},

	onDragMove: function (e) {
		//console.log("Drag move");
		var T = this,
			x, y;

		T._pointers[e.originalEvent.pointerId] = {
			pageX: e.pageX,
			pageY: e.pageY
		};

		var keys = _.keys(T._pointers);
		if (keys.length == 1) {
			if (!T._pinching) {
				var now = Date.now();

				if (!T._lockTested && now - T._lastTap > 50) {
					// determine if we can lock a direction
					var deltaX = Math.abs(T._dragStartPoint.x - e.pageX);
					var deltaY = Math.abs(T._dragStartPoint.y - e.pageY);

					if (deltaY > deltaX * 1.5) {
						T._lockX = true;
					}

					T._lockTested = true;
				}

				if (T._lockX) {
					x = T._x;
				} else {
					x = T._dragStartPagePoint.x - ((T._dragStartPoint.x - e.pageX) / T._zoom);
				}

				y = T._dragStartPagePoint.y - ((T._dragStartPoint.y - e.pageY) / T._zoom);

				T.setPosition(x, y, T._zoom, true, false);


				// inertia management
				if (T._dragEvents.length) {
					e.pv5TimeStamp = now;
					if (e.pv5TimeStamp - T._dragEvents[T._dragEvents.length - 1].pv5TimeStamp > 40) {
						//console.log("add event "+e.originalEvent.timestamp);
						T._dragEvents.push(e);
						if (T._dragEvents.length > 2) {
							T._dragEvents.shift();
						}
					}
				}
			}
		} else if (keys.length == 2) {
			// pinch
			var t1 = T._pointers[keys[0]];
			var t2 = T._pointers[keys[1]];
			var midX = (Math.abs(((t2.pageX - t1.pageX) / 2)) + t1.pageX);
			var midY = (Math.abs(((t2.pageY - t1.pageY) / 2)) + t1.pageY);
			var dist = Math.sqrt(Math.pow((t1.pageX - t2.pageX), 2) + Math.pow((t1.pageY - t2.pageY), 2));
			var scale = dist / T._touchStartDist;
			var newS = scale * T._touchStartScale;
			newS = T._clampZoom(newS);

			if (!T._pinching) {
				T.hideTiles();
				T._pinching = true;
			}
			var offset = T.$el.offset();
			//var pt={x:midX-offset.left,y:midY-offset.top};
			//T._vpToImage(pt);

			//T.zoomCentered(pt.x,pt.y,newS,midX-offset.left,midY-offset.top,true,false);
			T.zoomCentered(T._touchStartMidPt.x, T._touchStartMidPt.y, newS, midX - offset.left, midY - offset.top, false, false);
		}
	},

	onDragEnd: function (e) {
		var T = this;

		//console.log("Drag end");

		delete T._pointers[e.originalEvent.pointerId];

		var keys = _.keys(T._pointers);

		if (!T._pinching && T._dragEvents.length > 1) {
			// inertia management
			// http://stackoverflow.com/questions/4443526/jquery-ui-drag-easing-inertia
			// http://james.padolsey.com/javascript/fun-with-jquerys-animate/

			var x1, x2,
				y1, y2,
				t1, t2; // Time

			var minDistance = 30; // Minimum px distance object must be dragged to enable momentum.
			var lastE = T._dragEvents.shift();

			x1 = lastE.pageX;
			y1 = lastE.pageY;
			t1 = lastE.pv5TimeStamp;
			x2 = e.pageX;
			y2 = e.pageY;
			t2 = Date.now();

			// Deltas
			var dX = x2 - x1,
				dY = y2 - y1,
				dMs = Math.max(t2 - t1, 1);

			// Speeds
			var speedX = Math.max(Math.min(dX / dMs, 1), -1),
				speedY = Math.max(Math.min(dY / dMs, 1), -1);

			// Distance moved (Euclidean distance)
			var distance = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));

			var lockedX = T._lockX;

			T._lockX = false;

			if (distance > minDistance) {
				// Momentum
				//console.log("start momentum");
				var lastStepTime = new Date();
				$({
					count: 100
				}).animate({
					count: 0
				}, {
					duration: Math.max(Math.abs(speedX), Math.abs(speedY)) * 1500,
					step: function () {
						speedX *= (this.count / 100);
						speedY *= (this.count / 100);

						var now = Date.now();
						var stepDuration = now - lastStepTime;

						lastStepTime = now;

						//console.log("count: "+this.count+" speedY: "+speedY +" stepDuration:" +stepDuration);

						var new_x, new_y;
						if (lockedX) {
							new_x = T._x;
						} else {
							new_x = (T._x + ((speedX * stepDuration / 4) / T._zoom));
						}

						new_y = (T._y + ((speedY * stepDuration / 4) / T._zoom));

						T.setPosition(new_x, new_y, T._zoom, true, false);
					}
				});
			}
		}

		if (!keys.length) {
			$(window).off(".pv5-page");
			if (T._pinching) {
				T._pinching = false;
				T.saveZoomFav(T._zoom);
				T.setPosition(T._x, T._y, T._zoom, true, true);
				T.refresh();
			}
		}
	},

	/**
	 * save favorite zoom
	 * @param  {[type]} z [description]
	 * @return {[type]}   [description]
	 */
	saveZoomFav: function (z) {
		var T = this;
		if (z > T._zoomFit * 1.4) {
			T.zoomFav = z;
			T.trigger("change:zoom-fav", T);
		}
	},

	/**
	 * Hide all hd tiles, only background while be shown. Call refresh to reactivate tiles.
	 * This functionality is used while animating
	 */
	hideTiles: function () {
		var T = this;

		if (T.usePDF) {
			var nb_pages = T.model.get("isDouble") ? 2 : 1;
			if (window.devicePixelRatio <= 1) {
				// on passe en % pour faire l'animation
				T.$('canvas').css({
					width: (100 / nb_pages) + "%",
					height: "100%"
				});
			}
		}
		else {
			T.$(".tile").hide();
		}
	},

	/**
	 * Check if page displayed is a left page, useful only if we are in portrait orientation
	 * @return {Boolean}
	 */
	isLeftPage: function () {
		return this.page % 2 ? false : true;
	},

	close: function () {
		var T = this;
		T.$tileContainer = null;
		T._dragEvents = [];
		T._pointers = {};
		T._visible = [];
		T._tiles = {};
		T.stopListening();
		T.undelegateEvents();
	}

});